<template>
  <div>
    <title id="inertiaTitle">{{ pageTitle }}</title>
    <meta name="description" :content="seo.description" />
    <meta name="keywords" :content="seo.keywords" />
    <JsonLd :entries="jsonLdEntries" />

    <div class="min-h-screen flex flex-col justify-center overflow-hidden">
      <Menu :link="footer" />

      <main id="content" ref="content">
        <slot />
      </main>

      <div v-if="footer">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Footer from "./Footer.vue";
import JsonLd from "../../SEO/JsonLd.vue";
import {
  buildBreadcrumbSchema,
  buildPageSchema,
} from "../../../utils/structuredData";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    seo: {
      type: Object,
      default: () => ({
        title: "",
        description: "",
        keywords: "",
      }),
    },
    footer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      header: this.title == undefined ? "Youverse" : this.title + " | Youverse",
    };
  },
  components: {
    Menu,
    Footer,
    JsonLd,
  },

  computed: {
    pageTitle() {
      const baseTitle = this.seo?.title || this.title || "Youverse";

      if (baseTitle.includes(" | Youverse")) {
        return baseTitle;
      }

      return baseTitle ? `${baseTitle} | Youverse` : "Youverse";
    },
    jsonLdEntries() {
      const currentPath =
        typeof window !== "undefined" ? window.location.pathname : "/";
      const currentTitle = this.seo?.title || this.title || "Landing Page";

      return [
        buildPageSchema("WebPage", {
          name: currentTitle,
        }),
        buildBreadcrumbSchema([
          { name: "Home", url: "/" },
          {
            name: currentTitle,
            url: currentPath,
          },
        ]),
      ];
    },
  },
};
</script>
